export const checkLayoutReseting = state => state.build.layoutReset.isReseting;
